import { IDeviation } from 'src/generated-types/deviation'
import { getPlacementArray } from 'src/utils/function'

export const hasDeviationPlacementContent = (
  deviation?: IDeviation,
  customerId?: EntityId,
  localityId?: EntityId,
): boolean => {
  const mapMooringId = deviation?.mooringId ?? deviation?.effectiveMooringId
  const canShowMap = !!(customerId && localityId && mapMooringId)
  const placement = deviation?.placement ? getPlacementArray(deviation.placement) : undefined
  const hasLinkedWorkOrders = !!(deviation?.linkedWorkOrders && deviation.linkedWorkOrders.length > 0)
  const hasLinkedServices = !!(deviation?.scheduledServiceDeviations && deviation.scheduledServiceDeviations.length > 0)

  return canShowMap || !!placement || hasLinkedWorkOrders || hasLinkedServices
}
